// Application routes
export const ROUTES = {
  HOME: '/',
  ALL_EPISODES: '/episodes',
  EPISODE_DETAIL: '/episode/:episodeId'
};

// Helper to build episode detail route
export const getEpisodeDetailRoute = (episodeId) => `/episode/${episodeId}`;
